import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { CreateOcsConsoleRequestBody, PatchOcsConsoleRequestBody } from '@/api/apis/resources';
import { queryClient } from '@/queries';
import { Uuid } from '@/api/types';
import { ocsConsolesQueryKeys } from '@/queries/ocs-consoles/ocs-consoles.keys';

type RemoveOcsConsoleMutationVars = {
  id: string;
};

export const useRemoveOcsConsoleMutation = () => {
  return useMutation({
    mutationFn: (variables: RemoveOcsConsoleMutationVars) => api.resource.removeOcsConsole(variables.id),
    meta: {
      invalidates: [ocsConsolesQueryKeys.getList()],
    },
  });
};

export const useCreateOcsConsoleMutation = () => {
  return useMutation({
    mutationFn: (variables: CreateOcsConsoleRequestBody) => api.resource.createOcsConsole(variables),
    meta: {
      invalidates: [ocsConsolesQueryKeys.getList()],
    },
  });
};

export const useUpdateOcsConsoleMutation = () => {
  return useMutation({
    mutationFn: (variables: PatchOcsConsoleRequestBody & { id: string }) => {
      const updatedVariables = {
        ...variables,
        organType: variables.organType ? variables.organType : undefined,
      };
      return api.resource.updateOcsConsole(updatedVariables);
    },
    meta: {
      invalidates: [ocsConsolesQueryKeys.getList()],
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ocsConsolesQueryKeys.getItem(variables.id) });
    },
  });
};

export const useCopyInventoryMutation = () => {
  return useMutation({
    mutationFn: ({ fromCaseId, toCaseId }: { fromCaseId: Uuid; toCaseId: Uuid }) => {
      return api.resource.copyInventory(fromCaseId, toCaseId);
    },
  });
};
